// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { AnnotationTriageAreaId } from './AnnotationTriageAreaId'
import {
  AnnotationTriageAreaNavigation,
  AnnotationTriageAreaNavigationIcon,
} from './AnnotationTriageAreaNavigation'
import { AnnotationTriageAreaRoutes } from './AnnotationTriageAreaRoutes'

const LazyAnnotationTriageComponent = lazy(
  () => import('./AnnotationTriageArea'),
)

const AnnotationTriageComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyAnnotationTriageComponent />
  </SuspenseLoadingWrapper>
)

export const AnnotationTriageArea = {
  id: AnnotationTriageAreaId,
  Icon: AnnotationTriageAreaNavigationIcon,
  NavigationComponent: AnnotationTriageAreaNavigation,
  route: {
    path: AnnotationTriageAreaRoutes.route,
    component: AnnotationTriageComponent,
  },
}
